// extracted by mini-css-extract-plugin
export default {"search-container":"app-qualityControl-packetAssignment-modals-ReassignPacketsModal-ModalReassignment-module__tmDko7ShIB2H6V6dv0tQ"};